import { userFilterWithSearchCriteriaDetailed } from '@app/pcs/models';
import {gql} from 'apollo-angular';

export const createOrUpdateFilterMutation = gql`
    mutation createOrUpdateFilter($filter: FilterInput!) {
        filter(filter: $filter) {
            ...userFilterWithSearchCriteriaDetailed
        }
    }
    ${userFilterWithSearchCriteriaDetailed}
`;
